import axiosIns from '@/libs/axios'
import moment from 'moment'

const ROOT_URL = '/Admin/reports/director_reports'
export default {
  namespaced: true,
  state: {
    month: 'Ekim',
    year: '2025',
    incomesMonthly: {
      data: [],
      grandTotal: 0,
    },
    expensesMonthly: {
      data: [],
      grandTotal: 0,
    },
    incomesYearly: {
      data: [],
      grandTotal: 0,
    },
    expensesYearly: {
      data: [],
      grandTotal: 0,
    },
    banks: {
      data: [],
      grandTotal: {
        total_amount: 0,
        zekat_amount: 0,
        sadata_amount: 0,
      },
    },
    safes: {
      data: [],
      grandTotal: {
        total_amount: 0,
        zekat_amount: 0,
        sadata_amount: 0,
      },
    },
    promissories: {
      data: [],
      grandTotal: 0,
    },
    sadakaList: {
      data: [],
      grandTotal: 0,
    },
    zekatList: {
      data: [],
      grandTotal: 0,
    },
    filterParams: {
      sdate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      edate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
      year: moment().subtract(1, 'month').format('Y'),
    },
    filterData: {
      years: [],
    },
    loading: false,
  },
  getters: {
    month(state) {
      return state.month
    },
    year(state) {
      return state.year
    },
    incomesMonthly(state) {
      return state.incomesMonthly
    },
    expensesMonthly(state) {
      return state.expensesMonthly
    },
    incomesYearly(state) {
      return state.incomesYearly
    },
    expensesYearly(state) {
      return state.expensesYearly
    },
    banks(state) {
      return state.banks
    },
    safes(state) {
      return state.safes
    },
    promissories(state) {
      return state.promissories
    },
    sadakaList(state) {
      return state.sadakaList
    },
    zekatList(state) {
      return state.zekatList
    },
    filterData(state) {
      return state.filterData
    },
    filterParams(state) {
      return state.filterParams
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_REPORT_DATA(state, data) {
      state.month = data.month
      state.year = data.year
      state.incomesMonthly = data.incomesMonthly
      state.expensesMonthly = data.expensesMonthly
      state.incomesYearly = data.incomesYearly
      state.expensesYearly = data.expensesYearly
      state.banks = data.banks
      state.safes = data.safes
      state.promissories = data.promissories
      state.sadakaList = data.sadakaList
      state.zekatList = data.zekatList
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_FILTER_DATA(state, data) {
      state.filterData = data
    },
  },
  actions: {
    getReport({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .get(`${ROOT_URL}`, { params })
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    getFilterData({ commit }) {
      commit('SET_LOADING', true)
      return axiosIns
        .get(`${ROOT_URL}/filterData`)
        .then(response => {
          commit('SET_FILTER_DATA', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
